import React from "react";
import { condition } from "_helpers/experian";
import { flatMoney, FormatDate } from "_assets/js/helpers";
import "./Installments.scss";

// TransUnion-specific mappings
const ecoaDesignatorMap = {
  INDIVIDUAL: "Individual",
  JOINT_CONTRACT_LIABILITY: "Joint",
  AUTHORIZED_USER: "Authorized User",
};

const accountRatingMap = {
  "01": "Current",
  "02": "30 days late",
  "03": "60 days late",
  "04": "90 days late",
  "05": "120 days late",
  "07": "Making payments under wage earner plan",
  "08": "Repossession",
  "09": "Bad debt; placed for collection",
  "9B": "Collection account",
};

const termCalculator = (trade) => {
  if (!trade?.terms?.paymentScheduleMonthCount) return "-";
  const term = parseInt(trade?.terms?.paymentScheduleMonthCount) || 0;
  return term + " months";
};

function Installments(props) {
  const { installment } = props;
  return installment.map((m, i) => {
    const remarks = m?.remarks?.map((r) => r.code);
    let openOrClosed = m?.dateClosed ? "C" : "O";
    if (openOrClosed === "O" && parseInt(m?.currentBalance || "0") === 0) {
      openOrClosed = "P";
    }
    return (
      <div key={`crmortages-${i}`} className="wzrd-box installment">
        <div className="wzrd-body">
          <div className="trade-header">
            <h3>{m?.subscriber?.name?.unparsed}</h3>
            <p>
              {m?.subscriber?.industryCode}{" "}
              {remarks ? `/ ${remarks.join("; ")}` : ""}
            </p>
            <div>
              <b>Account #:</b> {m?.accountNumber || "-"}
            </div>
          </div>
          <div className={`trade-condition trade-${openOrClosed}`}>
            {condition[openOrClosed]}
          </div>
          <div className="trade-box">
            <div className="trade-items">
              <div className="trade-item">
                <h5>Payment Status</h5>
                <p>
                  {accountRatingMap[m?.accountRating] ||
                    m?.accountRating ||
                    "-"}
                </p>
              </div>
              <div className="trade-item">
                <h5>Responsibility</h5>
                <p>
                  {ecoaDesignatorMap[m?.ecoadesignator] ||
                    m?.ecoadesignator ||
                    "-"}
                </p>
              </div>
              <div className="trade-item">
                <h5>Account Term</h5>
                <p>{termCalculator(m) || "-"}</p>
              </div>
            </div>
            <div className="trade-items">
              <div className="trade-item">
                <h5>Portfolio Type</h5>
                <p>{m?.portfolioType || "-"}</p>
              </div>
            </div>
          </div>
          <div className="trade-list">
            <div>
              <h5>Open Date</h5>
              <p>{FormatDate(m?.dateOpened?.value)}</p>
            </div>
            <div>
              <h5>Status Date</h5>
              <p>{FormatDate(m?.dateEffective?.value)}</p>
            </div>
            <div>
              <h5>Closed Date</h5>
              <p>{FormatDate(m?.dateClosed?.value)}</p>
            </div>
            <div>
              <h5>Update Method</h5>
              <p>{m?.updateMethod || "-"}</p>
            </div>
            <div>
              <h5>Current Balance</h5>
              <p>{flatMoney(parseInt(m?.currentBalance || "0"))}</p>
            </div>
            <div>
              <h5>Scheduled Payment</h5>
              <p>
                {flatMoney(parseInt(m?.terms?.scheduledMonthlyPayment || "0"))}
              </p>
            </div>
            <div>
              <h5>High Credit</h5>
              <p>{flatMoney(parseInt(m?.highCredit || "0"))}</p>
            </div>
            <div>
              <h5>Past Due</h5>
              <p>{flatMoney(parseInt(m?.pastDue || "0"))}</p>
            </div>
            <div>
              <h5>Late 30 Days</h5>
              <p>
                {m?.paymentHistory?.historicalCounters?.late30DaysTotal || "0"}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  });
}

export default Installments;
